import { useState } from "react";
import { Check } from "lucide-react";
import { createCheckout, payWithRazorpay } from "@/lib/api";
import { toast } from "sonner";
import { usePages } from "@/lib/i18nPages";

const PLANS = [
  { id: "kirana_pro", name: "KashAssist Pro", price: "₹99", key: "kirana" },
];

export default function Pricing({ only, accent = "#006D5B" }) {
  const [loading, setLoading] = useState(null);
  const PR = usePages().pricing;
  const plans = only ? PLANS.filter((p) => p.id === only) : PLANS;

  const buy = async (planId) => {
    setLoading(planId);
    try {
      await payWithRazorpay(planId);
    } catch (e) {
      if (e?.message === "dismissed") { setLoading(null); return; }
      try {
        const { data } = await createCheckout(planId);
        window.location.href = data.checkout_url;
      } catch (e2) {
        console.error("checkout failed", e2);
        toast.error("Payment shuru nahi ho paya — thodi der baad try karo ya support se sampark karo.");
        setLoading(null);
      }
    }
  };

  const buyCard = async (planId) => {
    setLoading(planId);
    try {
      const { data } = await createCheckout(planId);
      window.location.href = data.checkout_url;
    } catch (e) {
      console.error("checkout failed", e);
      toast.error("Card payment shuru nahi ho paya — thodi der baad try karo.");
      setLoading(null);
    }
  };

  return (
    <section id="pricing" className="max-w-5xl mx-auto px-6 py-24">
      <h2 data-testid="pricing-heading" className="font-heading text-4xl md:text-5xl font-bold mb-3">
        {PR.titleA} <span style={{ color: accent }}>{PR.titleAccent}</span>
      </h2>
      <p className="text-gray-500 mb-12 text-lg">{PR.sub}</p>
      <div className={`grid grid-cols-1 ${plans.length > 1 ? "md:grid-cols-2" : "md:max-w-md"} gap-8`}>
        {plans.map((p) => (
          <div
            key={p.id}
            data-testid={`pricing-card-${p.id}`}
            style={{ borderColor: accent }}
            className="bg-white rounded-3xl p-8 border shadow-[0_20px_50px_rgba(0,0,0,0.08)] transition-transform duration-200 hover:-translate-y-1"
          >
            <span className="bg-[#FFC107] text-[#111827] text-xs font-bold px-3 py-1 rounded-full">
              {PR.unlimited}
            </span>
            <h3 className="font-heading text-2xl font-bold mt-4">{p.name}</h3>
            <p className="text-sm text-gray-500 mt-1">{PR[`${p.key}Aud`]}</p>
            <p className="mt-6 mb-6">
              <span className="font-heading text-5xl font-bold">{p.price}</span>
              <span className="text-gray-500">{PR.perMonth}</span>
            </p>
            <ul className="space-y-3 mb-8">
              {PR[`${p.key}Features`].map((f) => (
                <li key={f} className="flex items-center gap-2.5 text-sm">
                  <span style={{ backgroundColor: `${accent}1a`, color: accent }} className="w-5 h-5 rounded-full flex items-center justify-center shrink-0">
                    <Check size={12} strokeWidth={3} />
                  </span>
                  {f}
                </li>
              ))}
            </ul>
            <button
              data-testid={`buy-btn-${p.id}`}
              onClick={() => buy(p.id)}
              disabled={loading === p.id}
              style={{ backgroundColor: accent }}
              className="w-full py-3.5 rounded-full font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-60"
            >
              {loading === p.id ? PR.processing : PR.buyUpi}
            </button>
            <button
              data-testid={`buy-card-btn-${p.id}`}
              onClick={() => buyCard(p.id)}
              disabled={loading === p.id}
              style={{ color: accent }}
              className="w-full mt-2.5 text-[13px] font-semibold underline underline-offset-2 disabled:opacity-60"
            >
              {PR.buyCard}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
